export default [
  {
    path: '/apensar',
    name: 'apensar',
    component: () => import(/* webpackChunkName: "apensar" */ './Apensar.vue'),
    children: [
      {
        path: '/apensar/desapensar',
        name: 'desapensar',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "apensar" */ '@/components/apensar/Desapensar')
        }
      }
    ]
  }
]
